import React from "react";
import "./contact.css";

function Contact() {
  return (
    <div className="contact-container">
      <div className="hero-container">
        <h1>Contact</h1>
      </div>
      <div className="contact-info-container">
        <h3>Firstname Lastname</h3>
        <p>Job Title</p>
        <p>email@email.com</p>
        <p>123-456-7890</p>

        <h3>Firstname Lastname</h3>
        <p>Job Title</p>
        <p>email@email.com</p>
        <p>123-456-7890</p>

        <h3>Firstname Lastname</h3>
        <p>Job Title</p>
        <p>email@email.com</p>
        <p>123-456-7890</p>
      </div>
    </div>
  );
}

export default Contact;
